<template>
    <div class="bg">
        <div class="icon">
            <div class="icon-1"></div>
            <div class="icon-2"></div>
        </div>
        <div class="slogan">
            <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/slogan.png">
        </div>
        <div :class="isOff?'isOff':'isOn'" @click="changeOnOff" id="audio">
            <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/schedule/music.png">
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                isOff:false
            }
        },
        methods:{
            changeOnOff(){
                    this.isOff = !this.isOff;
                    this.$emit("changeOn",this.isOff)
                    console.log("isOff="+this.isOff)
                    localStorage.setItem("isOff",this.isOff)
            },
        },
        mounted(){
            let audio = localStorage.getItem("isOff")
            console.log("audio="+audio)
            if(audio==null){
                this.isOff = false
            } else if(audio=="false"){
                this.isOff= false
            }else{
                this.isOff = true
            }
            console.log("isOff="+this.isOff)
        }
    }
</script>

<style scoped lang="scss">
    .bg{
        position: relative;
    }
    .icon{
        width: 90%;
        height: 20px;
        text-align: center;
        margin: 0 auto;
        padding-top: 20px;
        display: flex;
        justify-content: space-between;
        .icon-1{
            width: 104px;
            height: auto;
            background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/icon-1.png") no-repeat;
            background-size: contain;
        }
        .icon-2{
            width: 80px;
            height: 300px;
            background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/icon-2.png") no-repeat;
            background-size:contain;
        }
    }
    .slogan{
        margin-top: -10px;
        position: relative;
        img:first-child{
            width: 100%;
            height: auto;
        }

        .heart{
            position: absolute;
            bottom: 18%;
            left: 42%;
            right: 0;
            img{
                width: 100%;
            }
        }
    }

    .isOff{
        position: absolute;
        z-index: 100;
        top: 20%;
        right: 5%;
        img{
            width: 30px;
        }
    }

    .isOn{
        position: absolute;
        z-index: 100;
        top: 20%;
        right: 5%;
        animation: rotating 2s linear infinite;
        img{
            width: 30px;
        }
    }

    @keyframes rotating {
        from { -webkit-transform: rotate(0) }
        to { -webkit-transform: rotate(360deg) }
    }

</style>